import * as React from "react";
import PropTypes from "prop-types";
import TablePagination from "@mui/material/TablePagination";

/**
 * Reusable pagination footer for data tables.
 *
 * Props:
 *  - count: number — total number of rows (after filtering)
 *  - page: number — current zero-indexed page
 *  - rowsPerPage: number
 *  - onPageChange: func(event, newPage)
 *  - onRowsPerPageChange: func(event)
 *  - rowsPerPageOptions: number[] (default [5, 10, 25])
 */
export default function TablePaginationControls({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 25],
}) {
  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  );
}

TablePaginationControls.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
};
